module.exports = __webpack_public_path__ + "static/media/indi.3ce45d68.jpeg";